import ru from './locale_ru';
import en from './locale_en';

export const locales = ['en', 'ru'];

const messages = {
  ru,
  en,
};

export default messages;


// WEBPACK FOOTER //
// ./src/messages/index.js